module.exports = __webpack_public_path__ + "0acdcec1.png";